import { Component } from "react";

import Url from "./Urls";
import Jsonfile from "../Utils/JsonFile";
import ConnectionServer from "./ConnectionServer";

var CampaignId = 3;

export class GetData extends Component {
  static Token = localStorage.getItem("Token");

  static GetdataSession() {
    this.Token = localStorage.getItem("Token");
    return "Bearer " + this.Token;
  }

  static GetHeader() {
    var Headers = "";
    if (this.Token != undefined) {
      Headers = {
        headers: { Authorization: this.GetdataSession() },
      };
    }
    return Headers;
  }

  static CheckTyped(CheckData) {
    if (typeof CheckData === "string") {
      return "string";
    } else if (Number.isInteger(CheckData)) {
      return "int";
    }
  }
  static CheckResult(Result) {
    if (Result[0] == ConnectionServer.Accept) Result[0] = true;
    else Result[0] = false;
    return Result;
  }

  static Exit() {
    localStorage.removeItem("Token");
    localStorage.removeItem("Menu");
    window.open("/", "_self");
  }
}

export class Transaction_Menu extends Component {
  static async Menu() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetMenu,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================LOGIN=================================================

export class Transaction_Login extends Component {
  static async Login(formdata) {
    var Headers = { headers: { "Content-Type": "multipart/form-data" } };
    var status = [true, false];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.Login_User,
      formdata,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async ComfirmLogin(formdata) {
    var Headers = { headers: { "Content-Type": "multipart/form-data" } };
    var status = [true, false];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.Confirm_Login,
      formdata,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      if (result[0] == true) localStorage.setItem("Token", result[2].data);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async Logout() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.Logout,
      undefined,
      GetData.GetHeader()
    ).then(function (result) {
      localStorage.removeItem("Token");
      localStorage.removeItem("shadUserId");
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================LANDING PAGE=================================================

export class Transaction_LandingPage extends Component {
  static async challenge() {
    var Items = Jsonfile.challengData;
    var status = [0, "ok", ""];
    status[2] = Items;
    return status;
  }
  static async gift() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetGift,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async beginadventure() {
    var Items = Jsonfile.beginadventure;
    var status = [0, "ok", ""];
    status[2] = Items;
    return status;
  }
  static async pieceOfBook() {
    var Items = Jsonfile.pieceOfBook;
    var status = [0, "ok", ""];
    status[2] = Items;
    return status;
  }
  static async introduce() {
    var Items = Jsonfile.introduce;
    var status = [0, "ok", ""];
    status[2] = Items;
    return status;
  }
  static async socialMedia() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetSocialMedia,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async statistics() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetStatistics,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async FAQ() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetFAQ,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async media() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetMedia,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async Supporters() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetSupporters,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async comrade() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetComrade,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async siteSetting() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetSiteSetting,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================BOOK=================================================

export class Transaction_Book extends Component {
  static async GetBooks(Title) {
    var status = [];
    var temUrl = Url.Get_Books;
    if (CampaignId != undefined && Title != undefined)
      temUrl += "?CampaignId=" + CampaignId + "&Title=" + Title;
    else if (CampaignId != undefined) temUrl += "?CampaignId=" + CampaignId;
    else temUrl += "?Title=" + Title;
    await ConnectionServer.Connection_AXIOS_GetJson(
      temUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetOneBooks(BookId) {
    var status = [];
    var tempUrl = Url.Get_GetOneBook;
    if (BookId != undefined) {
      tempUrl += "?BookId=" + BookId;
    }
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetLastPost(Bookid) {
    var status = [];
    var temUrl = Url.GetLastPost + "?BookId=" + Bookid;
    await ConnectionServer.Connection_AXIOS_GetJson(
      temUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddBookRead(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddBookRead,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddBookRate(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddBookRate,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddBookComment(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddBookComment,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetPhysicalBookList() {
    var status = [];
    var temUrl = Url.GetAvailableBooks;
    await ConnectionServer.Connection_AXIOS_GetJson(
      temUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetPhysicalPurchasedBooks() {
    var status = [];
    var temUrl = Url.GetPhysicalBookBuys;
    await ConnectionServer.Connection_AXIOS_GetJson(
      temUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddPhysicalBook(data) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddPhysicalBookBuy,
      data,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================CAMPAIGN=================================================

export class Transaction_Campaign extends Component {
  static async GetCampaigns(Name) {
    var status = [];
    var tempUrl = Url.GetCampaigns;
    if (Name != undefined) tempUrl += "?Name=" + Name;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });

    return status;
  }
  static async GetOneCampaign(camp) {
    var status = [];
    var tempUrl = Url.GetOneCampaign;
    if (CampaignId != undefined) tempUrl += "?campaignId=" + CampaignId;

    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================EXAM=================================================

export class Transaction_Exam extends Component {
  static async GetExam(BookId) {
    var status = [];
    var tempUrl = Url.GetExam;
    if (BookId != undefined) tempUrl += "?BookId=" + BookId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddExam(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddExam,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================ACTION=================================================

export class Transaction_Action extends Component {
  static async GetActions() {
    var status = [];
    var tempUrl = Url.GetActions;
    if (CampaignId != undefined) tempUrl += "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddAction(PostedData) {
    var status = [];
    var Headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: GetData.GetdataSession(),
      },
    };
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddAction,
      PostedData,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================CARD=================================================

export class Transaction_Card extends Component {
  static async Getcart() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetCart,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddCart(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddCart,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async DeleteCart(BookId) {
    var status = [];
    let tempurl = Url.DeleteCart + "?BookId=" + BookId;
    await ConnectionServer.Connection_AXIOS_DeleteJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async DeleteAll() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_DeleteJson(
      Url.DeleteAll,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================FORUM=================================================

export class Transaction_Forum extends Component {
  static async Topics(CampiagnId, BookId, Title) {
    var status = [false];
    var tempUrl = Url.Topics;
    if (CampiagnId != undefined && BookId != undefined && Title != undefined)
      tempUrl +=
        "?CampiagnId=" + CampiagnId + "&BookId=" + BookId + "&Title" + Title;
    else if (CampiagnId != undefined && BookId != undefined)
      tempUrl += "?CampiagnId=" + CampiagnId + "&BookId=" + BookId;
    else if (CampiagnId != undefined && Title != undefined)
      tempUrl += "?CampiagnId=" + CampiagnId + "&Title=" + Title;
    else if (BookId != undefined && Title != undefined)
      tempUrl += "?BookId=" + CampiagnId + "&Title=" + Title;
    else if (CampiagnId != undefined) tempUrl += "?CampiagnId=" + CampiagnId;
    else if (BookId != undefined) tempUrl += "?BookId=" + BookId;
    else if (Title != undefined) tempUrl += "?Title=" + Title;

    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async Posts(TopicId, UserId, Title, Page, Size) {
    var status = [false];
    var tempUrl = Url.Posts;
    if (
      TopicId != undefined &&
      UserId != undefined &&
      Title != undefined &&
      Page != undefined &&
      Size != undefined
    ) {
      tempUrl += `?TopicId="${TopicId}&UserId=${UserId}&Title=${Title}&Page=${Page}&Size=${Size}`;
    } else if (
      UserId != undefined &&
      Title != undefined &&
      Page != undefined &&
      Size != undefined
    ) {
      tempUrl += `?UserId=${UserId}&Title=${Title}&Page=${Page}&Size=${Size}`;
    } else if (Title != undefined && Page != undefined && Size != undefined) {
      tempUrl += `?Title=${Title}&Page=${Page}&Size=${Size}`;
    } else if (
      TopicId != undefined &&
      Title != undefined &&
      Page != undefined &&
      Size != undefined
    ) {
      tempUrl += `?TopicId="${TopicId}&Title=${Title}&Page=${Page}&Size=${Size}`;
    } else if (
      TopicId != undefined &&
      UserId != undefined &&
      Page != undefined &&
      Size != undefined
    ) {
      tempUrl += `?TopicId="${TopicId}&UserId=${UserId}&Page=${Page}&Size=${Size}`;
    }
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });

    return status;
  }
  static async Comments(UserId, PostId, Page, Size) {
    var status = [false];
    var tempUrl = Url.Comments;
    if (
      UserId != undefined &&
      PostId != undefined &&
      Page != undefined &&
      Size != undefined
    ) {
      tempUrl += `?UserId="${UserId}&PostId=${PostId}&Page=${Page}&Size=${Size}`;
    } else if (UserId != undefined && Page != undefined && Size != undefined) {
      tempUrl += `?UserId="${UserId}&Page=${Page}&Size=${Size}`;
    } else if (PostId != undefined && Page != undefined && Size != undefined) {
      tempUrl += `?PostId=${PostId}&Page=${Page}&Size=${Size}`;
    } else {
      tempUrl += `?PostId=${PostId}`;
    }

    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });

    return status;
  }
  static async Addpost(formdata) {
    var Headers = {
      headers: {
        Authorization: GetData.GetdataSession(),
        "Content-Type": "multipart/form-data",
      },
    };
    var status = [false];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddPost,
      formdata,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddComment(PostedData) {
    console.log(PostedData);
    var status = [false];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddComment,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      console.log(result);
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddPostLike(formdata) {
    var Headers = {
      headers: {
        Authorization: GetData.GetdataSession(),
        "Content-Type": "multipart/form-data",
      },
    };
    var status = [false];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddPostLike,
      formdata,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddPostReport(PostedData) {
    var status = [false];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddPostReport,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddPostRate(PostedData) {
    var status = [false];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddPostRate,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetHomeForum() {
    var status = [];
    var tempUrl = Url.HomeForum + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetOneBookForum(BookId) {
    var status = [];
    var tempUrl = Url.OneBookForum + "?BookId=" + BookId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetOneBookForumActions(
    BookId,
    ActionId,
    UserId,
    PageNumber,
    PageSize
  ) {
    var status = [];
    if (UserId) {
      var tempUrl = `${Url.OneBookForumActions}?BookId=${BookId}&ActionId=${ActionId}&UserId=${UserId}&PageNumber=${PageNumber}&PageSize=${PageSize}`;
    } else {
      var tempUrl = `${Url.OneBookForumActions}?BookId=${BookId}&ActionId=${ActionId}&PageNumber=${PageNumber}&PageSize=${PageSize}`;
    }
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetInformations() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.Informations,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetNews() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.News,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetTermsAndConditions() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.TermsAndConditions,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetTermsOfUses() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.TermsOfUses,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetFrequentlyQuestions() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.FrequentlyQuestions,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetHelps() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.Helps,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetCommonQuestions() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.CommonQuestions,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetIntroduce() {
    var Items = Jsonfile.Introduce;
    var status = [0, "ok", ""];
    status[2] = Items;
    return status;
  }
  static async GetAlerts() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetInformations,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetKetaBlog(ketablogId) {
    // var Items = Jsonfile.KetaBlog;
    // var status = [0, "ok", ""];
    // status[2] = Items;
    // return status;
    let tempurl = ketablogId
      ? Url.GetOneKetabLog + `?KetablogId=${ketablogId}`
      : Url.GetOneKetabLog;
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================PROFILE=================================================

export class Transaction_Profile extends Component {
  static async GetInvitees() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetInvitees,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetCommonQuestions() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetCommonQuestions,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetProvinces() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetProvinces,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetCities(ProvinceId) {
    let status = [];
    let tempurl = Url.GetCities + "?ProvinceId=" + ProvinceId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetOnlineChats(PageNumber, PageSize) {
    let status = [];
    let tempurl = Url.GetOnlineChats;
    if (PageNumber == undefined) {
      tempurl += "?PageSize=" + PageSize;
    } else if (PageSize == undefined) {
      tempurl += "?PageNumber=" + PageNumber;
    } else if (PageNumber != undefined && PageSize != undefined) {
      tempurl += "?PageNumber=" + PageNumber + "&PageSize=" + PageSize;
    }
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddOnlineChat(formData) {
    const Headers = {
      headers: {
        Authorization: GetData.GetdataSession(),
        "Content-Type": "multipart/form-data",
      },
    };
    let status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddOnlineChat,
      formData,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMyBook() {
    let status = [];
    let tempUrl = Url.GetMyBooks;
    if (CampaignId != undefined) tempUrl += "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });

    return status;
  }
  static async GetMyComments(Page, Size) {
    var status = [false];
    var tempUrl = Url.GetMyComments;
    if (Page != undefined && Size != undefined) {
      tempUrl += "?Page=" + Page + "&Size=" + Size;
    } else if (Page != undefined) {
      tempUrl += "?Page=" + Page;
    } else if (Size != undefined) {
      tempUrl += "?Size=" + Size;
    }
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetOfferedPriceForCharge() {
    var status = [false];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetOfferedPriceForCharge,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetUserInfo() {
    var status = [false];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetUserInfo,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      if (result[2] != undefined && result[2] != null && result[2] != "")
        status[2] = result[2].data;
    });
    return status;
  }
  static async GetProfile() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetProfile,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async GetUserProfile(userId) {
    var status = [];
    const connectionUrl = Url.GetUserProfile + `?UserId=${userId}`;
    await ConnectionServer.Connection_AXIOS_GetJson(
      connectionUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async GetAwardRecieved() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetAwardRecieved,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async GetTransfers() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetTransfers,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async TransferWallet(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.TransferWallet,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async Invite(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.SendInvite,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async UpdateUserInfo(PostedData) {
    var status = [];
    console.log("mamaddddd");
    console.log(PostedData);
    await ConnectionServer.Connection_AXIOS_UpdateJson(
      Url.UpdateUserInfo,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetSupportQuestions() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetSupports,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetGrades() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetGrades,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMethodOfIntroductions() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetMethodOfIntroductions,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetSchoolTypes() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetSchoolTypes,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetSchools(CityId, GradeId, SchoolTypeId, SchoolName) {
    var status = [];
    let tempUrl =
      Url.GetSchools +
      "?CityId=" +
      CityId +
      "&GradeId=" +
      GradeId +
      "&SchoolTypeId=" +
      SchoolTypeId +
      "&SchoolName=" +
      SchoolName;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMyActivity() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetMyActivity + "?CampaignId=" + CampaignId,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetSavePosts() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetSavePosts + "?CampaignId=" + CampaignId,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async DeleteSavePost(PostID) {
    var status = [];
    let tempurl = Url.DeleteSavePost + "?SavePostId=" + PostID;
    await ConnectionServer.Connection_AXIOS_DeleteJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddSavePost(PostedData) {
    var status = [false];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddSavePost,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================MainMenu=================================================

export class Transaction_MainMenu extends Component {
  static async Menu() {
    var Items = Jsonfile.MainMenu;
    var status = [0, "ok", ""];
    status[2] = Items;
    return status;
  }
}
export class Transaction_SafiranMenu extends Component {
  static async Menu() {
    var Items = Jsonfile.SafiranMenuJson;
    var status = [0, "ok", ""];
    status[2] = Items;
    return status;
  }
}

export class Transaction_Register extends Component {
  static async Shad(token, type) {
    if (!type) type = "shad";
    let status = [];
    let tempUrl = Url.ShadRegister + "?token=" + token + "&type=" + type;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================Payment=================================================

export class Transaction_Payment extends Component {
  static async CheckDiscountCode(Code) {
    var status = [];
    let tempurl =
      Url.CheckDiscountCode + "?Code=" + Code + "&CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async PaymentRequest(postedData) {
    var status = [];
    var Headers = {
      headers: {
        Authorization: GetData.GetdataSession(),
        "Content-Type": "multipart/form-data",
      },
    };
    let tempUrl = Url.PaymentRequest;
    await ConnectionServer.Connection_AXIOS_InsertJson(
      tempUrl,
      postedData,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async VerifyPayment(Authority, ChargePrice) {
    console.log(Url.VerifyPayment);
    var status = [];
    let tempUrl = Url.VerifyPayment + "?Authority=" + Authority;
    if (ChargePrice != undefined) {
      tempUrl += "&ChargePrice=" + ChargePrice;
    }
    await ConnectionServer.Connection_AXIOS_InsertJson(
      tempUrl,
      undefined,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetLastPayment() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.getLastPaymentUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetLastCharge() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.getLastChargeUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================SystemMessage=================================================

export class Transaction_SystemMessage extends Component {
  static async GetSystemMessages() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetSystemMessages,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================Ketablog=================================================

export class Transaction_ketablog extends Component {
  static async BlogSliderbottom() {
    var Items = Jsonfile.BlogSliderbottom;
    var status = [0, "ok", ""];
    status[2] = Items;
    return status;
  }
  static async BlogSliderhotText(ketablogId) {
    let status = [];
    let tempurl = ketablogId
      ? Url.GetKetabLogs + `?KetablogCategoryId=${ketablogId}`
      : Url.GetKetabLogs;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================CLUB=================================================

export class Transaction_Club extends Component {
  static async GetHomeClub(CampaignId = 3, UserId = "") {
    let status = [];
    let tempurl =
      Url.GetHomeClub + "?CampaignId=" + CampaignId + "&UserId=" + UserId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetBestOfCampaign() {
    let status = [];
    let tempurl = Url.GetBestOfCampaign + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMostInvite() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetMostInvite,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMostLike() {
    let status = [];
    let tempurl = Url.GetMostLike + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetBestMedalists() {
    let status = [];
    let tempurl = Url.GetBestMedalists + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMyCoins() {
    let status = [];
    let tempurl = Url.GetMyCoins + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMyScores() {
    let status = [];
    let tempurl = Url.GetMyScores + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMyMedals() {
    let status = [];
    let tempurl = Url.GetMyMedals + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMySigns() {
    let status = [];
    let tempurl = Url.GetMySigns + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetCoinHelps() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetCoinHelps,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetScoreHelps() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetScoreHelps,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMedalHelps() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetMedalHelps,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetSignHelps() {
    let status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetSignHelps,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetAwardCategories() {
    let status = [];
    let tempurl = Url.GetAwardCategories + "?CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetAwards(categoryId) {
    let status = [];
    let tempurl =
      Url.GetAwards + "?CategoryId=" + categoryId + "&CampaignId=" + CampaignId;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async TakeAward(formData) {
    var Headers = {
      headers: {
        Authorization: GetData.GetdataSession(),
        "Content-Type": "multipart/form-data",
      },
    };
    let status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.TakeAward,
      formData,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddGoldBox(formData) {
    var Headers = {
      headers: {
        Authorization: GetData.GetdataSession(),
        "Content-Type": "multipart/form-data",
      },
    };
    let status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.GoldBox,
      formData,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//=================================LEGATE=================================================

export class Transaction_LEGATE extends Component {
  static async GetLegateOrganizations() {
    let status = [];
    let tempurl = Url.GetLegateOrganiztionsUrl;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async GetLegateProfile() {
    let status = [];
    let tempurl = Url.GetLegateProfileUrl;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async AddLegateProfile(formData) {
    var Headers = {
      headers: {
        Authorization: GetData.GetdataSession(),
        "Content-Type": "multipart/form-data",
      },
    };
    let status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddLegateProfileUrl,
      formData,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetMyLegate() {
    let status = [];
    let tempurl = Url.GetMyLegateUrl;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetBestLegate() {
    let status = [];
    let tempurl = Url.GetBestLegateUrl;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempurl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }

  static async AddLegateInvite(formData) {
    var Headers = {
      headers: {
        Authorization: GetData.GetdataSession(),
        "Content-Type": "multipart/form-data",
      },
    };
    let status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddLegateInviteUrl,
      formData,
      Headers
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetTermAndCondition() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetTermAndConditionUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//================================= TV Plus Exam =================================================

export class Transaction_PlusExams extends Component {
  static async GetNumberOfUser() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetNumberPlusExamsUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}
//================================= TV EXAM =================================================

export class Transaction_TvExam extends Component {
  static async GetTvExams() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetTvExamsUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetOneTvExam(id) {
    var status = [];
    var tempUrl = Url.GetOneTvExamurl;
    if (id != undefined) tempUrl += "?id=" + id;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddTvExam(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddTvExamUrl,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}

//================================= TV EXAM =================================================

export class Transaction_KnowledgeExam extends Component {
  static async GetKnowledgeExams() {
    var status = [];
    await ConnectionServer.Connection_AXIOS_GetJson(
      Url.GetKnowledgeExamsUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async GetOneKnowledgeExam(id) {
    var status = [];
    var tempUrl = Url.GetOneKnowledgeExamurl;
    if (id != undefined) tempUrl += "?id=" + id;
    await ConnectionServer.Connection_AXIOS_GetJson(
      tempUrl,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
  static async AddKnowledgeExam(PostedData) {
    var status = [];
    await ConnectionServer.Connection_AXIOS_InsertJson(
      Url.AddKnowledgeExamUrl,
      PostedData,
      GetData.GetHeader()
    ).then(function (result) {
      GetData.CheckResult(result);
      status[0] = result[0];
      status[1] = result[1];
      status[2] = result[2];
    });
    return status;
  }
}
